import { z } from 'zod';
// Campaign refinement chat — session 2 of plan mode.
//
// After the panel lands an initial draft + planning log, the founder
// reads it and reacts in natural language ("the budget split is
// wrong, give meta 70%"; "drop the second hook, it's too close to
// the first"). Each turn the api appends the founder message, runs
// mag-campaign-refiner, appends Mag's reply, and updates the draft
// in place — no draft versioning, one mutable plan.
//
// Persisted on campaigns.refinement_messages so the founder doesn't
// lose context on refresh. Same shape as IntakeMessage to keep the
// chat renderer trivial.
export const refinementChangeSchema = z.object({
    /** Deliverable id, budget field, or audience field that moved. */
    target: z.string().min(1).max(120),
    /** One-line description of the change. ("dropped — too close to
     *  paid-urgency-24h", "lifted $14→$20"). */
    note: z.string().min(1).max(280),
});
/** One turn in the refinement chat. Mirrors IntakeMessage so the
 *  renderer can share rendering code. Mag turns carry an optional
 *  `changes` payload — the structured trail behind the prose reply,
 *  used by the review surface to highlight what moved. */
export const refinementMessageSchema = z.object({
    role: z.enum(['mag', 'founder']),
    body: z.string().min(1).max(4000),
    createdAt: z.string().datetime(),
    /** Only present on mag turns produced by the refiner. The synth-
     *  esizer's planning_log carries the panel-round summary; this
     *  carries each per-turn refinement summary. Empty array means
     *  "i pushed back and changed nothing". */
    changes: z.array(refinementChangeSchema).max(8).optional(),
    /** LLM cost for the mag turn that produced this message. Founder
     *  turns carry 0. Used by the dashboard's total-cost rollup. */
    costUsd: z.number().min(0).optional(),
});
//# sourceMappingURL=campaign-refinement.js.map